import React from 'react';

import { cn } from '@/utils/classname';

export interface SettingCompactCardProps {
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  'data-tutorial'?: string;
}

/**
 * Compact horizontal card for settings with consistent min-height layout.
 *
 * Designed for horizontal display cards (unlike SettingContentCard which is vertical).
 * Provides:
 * - Border + background (matches SettingContentCard)
 * - Horizontal flex layout (items-center)
 * - Fixed minimum height (min-h-24 = 96px)
 * - Consistent padding (px-4 py-2)
 * - Text size constraint (text-sm)
 *
 * Use cases:
 * - Scan settings cards (scan level, source IP, schedule)
 * - Notification integration cards
 * - Feature flag toggles
 * - Any horizontal display + action pattern
 */
export const SettingCompactCard: React.FC<SettingCompactCardProps> = ({
  children,
  className,
  'data-testid': testId,
  'data-tutorial': tutorial,
}) => {
  return (
    <div
      className={cn(
        'border-chariot-stroke bg-chariot-background-primary rounded-md border',
        'relative flex items-center',
        'min-h-24 px-4 py-2',
        'text-sm',
        className
      )}
      data-testid={testId}
      data-tutorial={tutorial}
    >
      {children}
    </div>
  );
};
